export default __webpack_public_path__ + "static/media/blank.44e458e0.pdf";